import { IProject } from "../models/project.model";
import ServiceBase from "./base.service";

export class ProjectsService extends ServiceBase {
  search = async (query: string, excludeProjects: string[]): Promise<IProject[]> =>
    this.get<IProject[]>(`projects?query=${query}&top=10&exclude=${excludeProjects.join(",")}`);
}

const projectsService = new ProjectsService();

export default projectsService;
